import { render, staticRenderFns } from "./SolicitacaoEnvio.vue?vue&type=template&id=b9d897b0&scoped=true"
import script from "./SolicitacaoEnvio.vue?vue&type=script&lang=js"
export * from "./SolicitacaoEnvio.vue?vue&type=script&lang=js"
import style0 from "./SolicitacaoEnvio.vue?vue&type=style&index=0&id=b9d897b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d897b0",
  null
  
)

export default component.exports